export const Progress = {
  Name: "Мій прогрес",
  Emoji: "🧩",
};
